"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheManager = void 0;
var AppMemoryStorage_1 = require("./AppMemoryStorage");
var rxjs_1 = require("rxjs");
var CryptoJS = require("crypto-js");
var operators_1 = require("rxjs/operators");
var inversify_1 = require("inversify");
var TypeDefs_1 = require("../../TypeDefs");
var CacheManager = exports.CacheManager = /** @class */ (function () {
    function CacheManager(applicationGuard) {
        this.applicationGuard = applicationGuard;
        this.appMemoryStorage = new AppMemoryStorage_1.AppMemoryStorage();
    }
    CacheManager_1 = CacheManager;
    CacheManager.prototype.clearCache = function (key, storage) {
        var _this = this;
        var storageToUse = this.getStorageToUse(storage);
        Object.entries(storageToUse).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            if (k.indexOf(key) !== -1) {
                storageToUse.removeItem(k);
            }
        });
        Object.entries(this.appMemoryStorage).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            if (k.indexOf(key) !== -1) {
                _this.appMemoryStorage.removeItem(k);
            }
        });
    };
    CacheManager.prototype.clearAll = function (storage) {
        var _this = this;
        var storageToUse = this.getStorageToUse(storage);
        Object.entries(storageToUse).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            if (k.indexOf(CacheManager_1.CACHE_PREFIX) !== -1) {
                storageToUse.removeItem(k);
            }
        });
        Object.entries(this.appMemoryStorage).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            if (k.indexOf(CacheManager_1.CACHE_PREFIX_MEM) !== -1) {
                _this.appMemoryStorage.removeItem(k);
            }
        });
    };
    CacheManager.prototype.saveObservable = function (key, data, useEncryption, storage, timeToLiveSec) {
        var _this = this;
        data.subscribe(function (value) {
            _this.storeItemInMemory(key, value, timeToLiveSec);
            if (useEncryption) {
                _this.getSecretPassphrase().subscribe(function (passphrase) {
                    var toSave = CryptoJS.AES.encrypt(JSON.stringify(value), passphrase).toString();
                    _this.storeItem(key, toSave, true, _this.getStorageToUse(storage), timeToLiveSec);
                });
            }
            else {
                _this.storeItem(key, value, false, _this.getStorageToUse(storage), timeToLiveSec);
            }
        });
    };
    CacheManager.prototype.tryGetObservable = function (key, storage) {
        var _this = this;
        var result = this.getItemFromMemory(key) || this.getItemFromCache(key, storage);
        if (result == null) {
            return null;
        }
        // Check if expired
        if (Date.now() > result.expires) {
            this.clearCache(key, storage);
            return null;
        }
        // Check owner
        if (result.encrypted && !result.owner && this.getOwner() !== result.owner) {
            this.clearCache(key, storage);
            return null;
        }
        if (result.encrypted) {
            return this.getSecretPassphrase()
                .pipe((0, operators_1.map)(function (passphrase) {
                try {
                    var bytes = CryptoJS.AES.decrypt(result.data, passphrase);
                    var originalText = bytes.toString(CryptoJS.enc.Utf8);
                    var item = JSON.parse(originalText);
                    _this.storeItemInMemory(key, item, result.expires / 1000);
                    return item;
                }
                catch (e) {
                    _this.clearCache(key, storage);
                    return (0, rxjs_1.of)(null);
                }
            }));
        }
        else {
            return (0, rxjs_1.of)(result.data);
        }
    };
    CacheManager.prototype.getSecretPassphrase = function () {
        var _this = this;
        if (!this.applicationGuard) {
            throw new Error("Unable to encrypt cahe value. IApplicationGuard is not bind to container");
        }
        return this.applicationGuard
            .fetchToken() // Token itself is not used, however this ensures application guard has done authentication and user data population
            .pipe((0, operators_1.map)(function (token) {
            return _this.applicationGuard.getUser().id;
        }));
    };
    CacheManager.prototype.isCached = function (key, storage) {
        return this.appMemoryStorage.getItem(CacheManager_1.CACHE_PREFIX_MEM + key) != null ||
            this.getStorageToUse(storage).getItem(CacheManager_1.CACHE_PREFIX + key) != null;
    };
    CacheManager.prototype.storeItem = function (key, value, encrypted, storage, timeToLiveSec) {
        var ttlToUse = timeToLiveSec || CacheManager_1.DEFAULT_TIME_TO_LIVE;
        storage.setItem(CacheManager_1.CACHE_PREFIX + key, JSON.stringify({
            encrypted: encrypted,
            data: value,
            expires: Date.now() + (ttlToUse * 1000),
            owner: encrypted ? this.getOwner() : undefined
        }));
    };
    CacheManager.prototype.storeItemInMemory = function (key, value, timeToLiveSec) {
        var ttlToUse = timeToLiveSec || CacheManager_1.DEFAULT_TIME_TO_LIVE;
        this.appMemoryStorage.setItem(CacheManager_1.CACHE_PREFIX_MEM + key, JSON.stringify({
            data: value,
            encrypted: false,
            expires: Date.now() + (ttlToUse * 1000)
        }));
    };
    CacheManager.prototype.getItemFromCache = function (key, storage) {
        var item = this.getStorageToUse(storage).getItem(CacheManager_1.CACHE_PREFIX + key);
        if (item) {
            return JSON.parse(item);
        }
        else {
            return null;
        }
    };
    CacheManager.prototype.getItemFromMemory = function (key) {
        var item = this.appMemoryStorage.getItem(CacheManager_1.CACHE_PREFIX_MEM + key);
        if (item) {
            return JSON.parse(item);
        }
        else {
            return null;
        }
    };
    CacheManager.prototype.getOwner = function () {
        if (this.applicationGuard.isAuthenticated() && this.applicationGuard.getUser() != null) {
            return this.applicationGuard.getUser().name;
        }
        return;
    };
    CacheManager.prototype.getStorageToUse = function (storage) {
        if (storage) {
            return storage;
        }
        // Fallback to memory storage if session storage not supported
        if (window.sessionStorage) {
            return window.sessionStorage;
        }
        return this.appMemoryStorage;
    };
    var CacheManager_1;
    CacheManager.DEFAULT_TIME_TO_LIVE = 300;
    CacheManager.CACHE_PREFIX = "Cache_";
    CacheManager.CACHE_PREFIX_MEM = "CacheMem_";
    CacheManager = CacheManager_1 = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(TypeDefs_1.TypeDefs.ApplicationGuard)),
        __param(0, (0, inversify_1.optional)()),
        __metadata("design:paramtypes", [Object])
    ], CacheManager);
    return CacheManager;
}());
//# sourceMappingURL=CacheManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/impl/CacheManager.js
// module id = 899
// module chunks = 0